import { init } from '@paralleldrive/cuid2'

export function generateId(length = 23) {
  return init({ length })()
}
